export enum RasterBandColorinterp {
  Gray = 'gray',
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Alpha = 'alpha',
  Palette = 'palette',
}
